export type TranslationKey = 
  | 'success' | 'error' | 'cancel' | 'save' | 'delete' | 'edit' | 'add' | 'back'
  | 'workflowHub' | 'onboarding' | 'active' | 'extension' | 'offboarding' | 'complete'
  | 'addCustomField' | 'editField' | 'fieldName' | 'note' | 'fieldNotePlaceholder' | 'noteSupportsHtml' | 'displayNoteInGrid' | 'displayNoteHelpText' | 'inputType' | 'colorCodeInput'
  | 'allowMultipleSelections' | 'dropdownOptions' | 'visibleOnStages' | 'backToColumns'
  | 'fieldCreated' | 'fieldUpdated' | 'fieldDeleted' | 'noCustomFieldsAvailable'
  | 'selectOptions' | 'editColumns'
  | 'retainColumnData' | 'retainColumnDataLabel' | 'retainColumnDataDescription'
  | 'clear' | 'clearAll' | 'showMore' | 'typeToFilter' | 'enterValue' | 'startDate' | 'endDateOptional' | 'noRecordsFound' | 'loading'
  | 'filter' | 'clearFilters' | 'clearSelection' | 'itemsSelected' | 'selectAction'
  | 'selectOption' | 'selectDate' | 'clickToEdit' | 'today'
  | 'apply' | 'showVisibleFieldsOnly' | 'customColumn' | 'search'
  | 'january' | 'february' | 'march' | 'april' | 'may' | 'june' | 'july' | 'august' | 'september' | 'october' | 'november' | 'december'
  | 'sun' | 'mon' | 'tue' | 'wed' | 'thu' | 'fri' | 'sat'
  | 'previous' | 'next' | 'showingRecords' | 'pageOf' | 'rowsPer'
  | 'editWorkItems' | 'addNewField' | 'close' | 'ok' | 'option'
  | 'editItems' | 'moveTo' | 'areYouSure' | 'moveToConfirm' | 'yesUpdate' | 'processing' | 'cancelWorkOrder' | 'goBack'
  | 'openFboWorkOrder' | 'noActionsAvailable' | 'confirmDeleteOption' | 'noSuggestions'
  | 'myViews' | 'teamViews' | 'sharedWithMe' | 'allCompany' | 'saveViewAs' | 'saveThisView' | 'title' | 'myCustomView' | 'description' | 'addDescriptionForView' | 'showDescriptionOnHover' 
  | 'deleteViewConfirmation' | 'deleteViewWarning' | 'share' | 'saveChanges' | 'changesSuccess' | 'saveAsNew' | 'deleteView' 
  | 'saveView' | 'visibility' | 'private' | 'public' | 'shareWith' | 'shareWithPlaceholder'
  | 'hiddenColumns' | 'visibleColumns' | 'editColumnsSubtitle' | 'nameYourCustomView'
  | 'manageViews' | 'searchViews' | 'showView' | 'view' | 'editView' | 'noMyViews' | 'noSharedViews' | 'noPublicViews' | 'showVisibleViewsOnly' | 'createView' | 'viewNotFound' | 'viewVisibility' | 'hideView' | 'viewHidden' | 'viewShown'
  | 'viewSavedSuccessfully' | 'columnConfigurationUpdatedSuccessfully' | 'failedToSaveView'
  | 'unsavedChangesTitle' | 'unsavedChangesWarning' | 'switchView'
  | 'inputTypeText' | 'inputTypeYesNo' | 'inputTypeDropdown' | 'inputTypeDate' | 'inputTypeNumber' | 'inputTypeEmail' | 'inputTypeChecklist'
  | 'blank'
  | 'automations'
  | 'showChangesInProgress'
  | 'historyOfChanges' | 'searchChanges' | 'loadingHistory' | 'noChangesFound' | 'tryAdjustingSearch' | 'changesFound' | 'changeFound' | 'new' | 'by' | 'unknownUser' | 'unknownTime' | 'unknownDate' | 'changeReason' | 'changes' | 'loadMore' | 'viewHistory' | 'viewMessages'
  | 'pinTooltip' | 'unpinTooltip'
  | 'confirmBulkUpdate' | 'bulkUpdateConfirmMessage' | 'autoProcessIn' | 'seconds' | 'confirmUpdate' | 'confirm' | 'yes' | 'no' | 'someValuesEmpty'
  | 'viewSelector'
  | 'all' | 'lastWeek' | 'lastMonth' | '90days' | 'lastYear' | 'custom' | 'stage' | 'true' | 'false'
  | 'changeHistory' | 'automationEmails' | 'historyOf' | 'candidate' | 'allStages' | 'allUsers'
  | 'adjustSearchFilters' | 'showing' | 'change' | 'additionalInfo' | 'clickToExpand' | 'clickToCollapse'
  | 'featureComingSoon' | 'endDate' | 'of' | 'sentTo' | 'sentFrom' | 'sentAt' | 'subject' | 'noEmailsFound' | 'loadingEmails' | 'searchEmailSubject' | 'automationEmailHistoryOf'
    | 'stages' | 'selectRecipient' | 'allRecipients' | 'to' | 'from' | 'showLess'
    | 'searchWorkers' | 'searchWorker' | 'workerResults' | 'workerName' | 'clientName' | 'workOrderId' | 'searchHelperText'
  | 'whoCanViewColumn' | 'noUsersSelected' | 'updateColumnAccess'
  | 'confirmMakePrivate' | 'confirmMakePrivateMessage' | 'confirmMakePublic' | 'confirmMakePublicMessage'
  | 'privateColumn' | 'default' | 'searchUsersPlaceholder' | 'noUsersFound'
  | 'privateColumnWarningTitle' | 'privateColumnWarningMessage' | 'saveAnyway'
  | 'worker' | 'workOrderIdLabel' | 'itemsCompleted' | 'addNewItem' | 'unsavedChecklistChanges' | 'unsavedChecklistMessage'
  | 'added' | 'removed' | 'completed' | 'uncompleted' | 'deleted' | 'restored'
  | 'duplicateItemError' | 'duplicateItemsPreventSave'
  | 'fixedPosition' | 'dateFormatting' | 'shortDateFormat' | 'dateTimeFormat' | 'manageColumnsDescription';

export const translations = {
  en: {
    // Common
    success: 'Success',
    error: 'Error',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    back: 'Back',
    editWorkItems: 'Edit work items',
    editItems: 'Edit items',
    addNewField: 'Add new field',
    close: 'Close',
    ok: 'OK',
    option: 'Option',
    filter: 'Filter',
    clearFilters: 'Clear filters',
    clearSelection: 'Clear selection',
    itemsSelected: 'items selected',
    selectAction: 'Select action',
    clickToEdit: 'Click to edit',
    today: 'Today',
    apply: 'Apply',
    search: 'Search',
    
    // Calendar
    january: 'January',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'September',
    october: 'October',
    november: 'November',
    december: 'December',
    
    sun: 'Sun',
    mon: 'Mon',
    tue: 'Tue',
    wed: 'Wed',
    thu: 'Thu',
    fri: 'Fri',
    sat: 'Sat',
    
    // Workflow Hub
    workflowHub: 'Workflow Hub',
    onboarding: 'Onboarding',
    active: 'Active',
    extension: 'Extension',
    offboarding: 'Offboarding',
    complete: 'Complete',
    
    // Field Modal
    addCustomField: 'Add custom field',
    editField: 'Edit field',
    fieldName: 'Field name',
    note: 'Note',
    fieldNotePlaceholder: 'Add a note for this field...',
    noteSupportsHtml: 'Note supports HTML formatting',
    displayNoteInGrid: 'Display note on column header',
    displayNoteHelpText: 'When checked, an info icon with a note will appear in the column header',
    inputType: 'Input type',
    colorCodeInput: 'Colour code input',
    allowMultipleSelections: 'Allow multiple selections',
    dropdownOptions: 'Dropdown Options',
    visibleOnStages: 'Visible on stages',
    backToColumns: 'Back to columns',
    showVisibleFieldsOnly: 'Show visible fields only',
    customColumn: 'Custom column',
    retainColumnData: 'Retain Column Data',
    retainColumnDataLabel: 'Retain Column Data',
    retainColumnDataDescription: 'Retains the column data for the same assignment ID across all new records',
    
    // Input Types
    inputTypeText: 'Text',
    inputTypeYesNo: 'Yes/No',
    inputTypeDropdown: 'Dropdown',
    inputTypeDate: 'Date',
    inputTypeNumber: 'Number',
    inputTypeEmail: 'Email',
    inputTypeChecklist: 'Checklist',
    blank: '(blank)',
    
    // Messages
    fieldCreated: 'Custom field created successfully',
    fieldUpdated: 'Field updated successfully',
    fieldDeleted: 'Field deleted successfully',
    noCustomFieldsAvailable: 'No more Custom Fields available. Please, create new or remove the existing ones.',
    
    // Form placeholders and labels
    selectOptions: 'Select options',
    selectOption: 'Select option',
    selectDate: 'Select date',
    editColumns: 'Edit columns',
    clear: 'Clear',
    clearAll: 'Clear All',
    showMore: 'Show more',
    typeToFilter: 'Type to filter...',
    enterValue: 'Enter value...',
    startDate: 'Start date',
    endDateOptional: 'End date (optional)',
    noRecordsFound: 'No records found',
    loading: 'Loading...',
    previous: 'Previous',
    next: 'Next',
    showingRecords: '{start}-{end} of {total}',
    pageOf: 'Page {current} of {total}',
    rowsPer: 'Rows per page',
    showChangesInProgress: 'Items in Progress',
    moveTo: 'Move to',
    areYouSure: 'Are you sure?',
    moveToConfirm: 'This will update {count} record{s} to status "{status}".',
    yesUpdate: 'Yes, update',
    processing: 'Processing...',
    cancelWorkOrder: 'Cancel work order',
    goBack: 'No, go back',
    openFboWorkOrder: 'Open FBO Work Order',
    noActionsAvailable: 'No actions available',
    confirmDeleteOption: 'Are you sure you want to remove this option?',
    noSuggestions: 'No suggestions found',
    
    // View Selector
    myViews: 'My views',
    teamViews: 'Team views',
    sharedWithMe: 'Shared with me',
    allCompany: 'All company',
    saveViewAs: 'Save view as',
    title: 'Title',
    myCustomView: 'My custom view',
    description: 'Description',
    addDescriptionForView: 'Add a description for this view',
    showDescriptionOnHover: 'Show description on hover in dropdown',
    deleteViewConfirmation: 'Are you sure you want to delete this view?',
    deleteViewWarning: 'This view will be deleted for everyone it has been shared with. You cannot undo this action.',
    share: 'Share',
    saveChanges: 'Save changes',
    changesSuccess: 'Changes saved successfully',
    saveAsNew: 'Save as new',
    deleteView: 'Delete view',
    viewNotFound: 'View not found. It may have been deleted.',
    viewVisibility: 'View visibility',
    hideView: 'Hide view',
    viewHidden: 'View hidden successfully',
    viewShown: 'View shown successfully',
    saveView: 'Save view',
    saveThisView: 'Save this view',
    visibility: 'Visibility',
    private: 'Private',
    public: 'Public',
    shareWith: 'Share with',
    shareWithPlaceholder: 'Enter email addresses',
    
    // Edit Columns Modal
    hiddenColumns: 'Hidden columns',
    visibleColumns: 'Visible columns',
    editColumnsSubtitle: 'Hide, show, order, edit and create custom columns.',
    nameYourCustomView: 'Name your custom view',
    
    // Manage Views Modal
    manageViews: 'Manage views',
    searchViews: 'Search views',
    showView: 'Show view',
    view: 'View',
    editView: 'Edit view',
    createView: 'Create view',
    noMyViews: 'No views found',
    noSharedViews: 'No shared views found',
    noPublicViews: 'No public views found',
    showVisibleViewsOnly: 'Show visible views only',
    viewSavedSuccessfully: 'View saved successfully',
    columnConfigurationUpdatedSuccessfully: 'Column configuration updated successfully',
    failedToSaveView: 'Failed to save view',
    unsavedChangesTitle: 'Unsaved Changes',
    unsavedChangesWarning: 'You have unsaved changes to your filters. Switching views will discard these changes. Are you sure you want to continue?',
    switchView: 'Switch View',
    automations: 'Automations',
    
    // Audit History
    historyOfChanges: 'History of Changes',
    searchChanges: 'Search changes...',
    loadingHistory: 'Loading history...',
    noChangesFound: 'No changes found',
    tryAdjustingSearch: 'Try adjusting your search terms',
    changesFound: 'changes found',
    changeFound: 'change found',
    new: 'New',
    by: 'by',
    unknownUser: 'Unknown User',
    unknownTime: 'Unknown time',
    unknownDate: 'Unknown date',
    changeReason: 'Change Reason',
    changes: 'Changes',
    loadMore: 'Load More',
    viewHistory: 'View History',
    viewMessages: 'View Messages',
    pinTooltip: 'Drag and drop this pin onto any column to pin it.',
    unpinTooltip: 'Click to unpin this column or drag and drop it to another one.',
    confirmBulkUpdate: 'Confirm Bulk Update',
    bulkUpdateConfirmMessage: 'You are about to update items. This action cannot be undone.',
    confirmUpdateMessage: 'You are about to update {count} record(s) with this bulk action. Do you want to proceed?',
    autoProcessIn: 'Auto-processing in',
    seconds: 'seconds',
    confirmUpdate: 'Confirm Update',
    confirm: 'Confirm',
    yes: 'Yes',
    no: 'No',
    someValuesEmpty: 'Some values are empty and will clear the existing data.',
    viewSelector: 'View selector',
    
    // Additional Audit History translations
    all: 'All',
    lastWeek: 'Last Week',
    lastMonth: 'Last Month',
    '90days': '90 Days',
    lastYear: 'Last Year',
    custom: 'Custom',
    stage: 'Stage',
    true: 'True',
    false: 'False',
    changeHistory: 'Change History',
    automationEmails: 'Automation Emails',
    historyOf: 'History of',
    candidate: 'Candidate',
    allStages: 'All Stages',
    allUsers: 'All Users',
    adjustSearchFilters: 'Try adjusting your search or filters',
    showing: 'Showing',
    change: 'change',
    additionalInfo: 'Additional Info',
    clickToExpand: 'Click to expand details',
    clickToCollapse: 'Click to collapse details',
    featureComingSoon: 'This feature is coming soon',
    endDate: 'End Date',
    of: 'of',
    sentTo: 'Sent to',
    sentFrom: 'From',
    sentAt: 'Sent at',
    subject: 'Subject',
    noEmailsFound: 'No emails found',
    loadingEmails: 'Loading emails...',
    searchEmailSubject: 'Search email subject...',
    automationEmailHistoryOf: 'Automation Email History of',
    stages: 'Stages',
    selectRecipient: 'Select recipient',
    allRecipients: 'All recipients',
    to: 'To',
    from: 'From',
    showLess: 'Show less',
    
    // Worker Search
    searchWorkers: 'Search Workers',
    searchWorker: 'Search Worker',
    workerResults: 'Worker Results',
    workerName: 'Worker Name',
    clientName: 'Client',
    workOrderId: 'Work Order ID',
    searchHelperText: 'Type at least 2 characters to search for workers',
    
    // Private Columns
    whoCanViewColumn: 'Who can view this column',
    noUsersSelected: 'No users selected',
    updateColumnAccess: 'Update column access',
    confirmMakePrivate: 'Make Column Private',
    confirmMakePrivateMessage: 'Only users with access will be allowed to see this column.',
    confirmMakePublic: 'Make Column Public',
    confirmMakePublicMessage: 'This column will become public and visible to everyone. Authorized users will be reset.',
    
    // Private Column
    privateColumn: 'Private column:',
    default: '(default)',
    searchUsersPlaceholder: 'Search users by name or email...',
    noUsersFound: 'No users found',
    privateColumnWarningTitle: 'Private Column Filters Warning',
    privateColumnWarningMessage: 'This public view contains filters on private columns. Other users who don\'t have access to these private columns may not see the same results or may encounter errors when using this view. Are you sure you want to save this public view?',
    saveAnyway: 'Save Anyway',
    
    // Checklist Panel
    worker: 'Worker',
    workOrderIdLabel: 'Work Order ID',
    itemsCompleted: 'items completed',
    addNewItem: 'Add new item',
    unsavedChecklistChanges: 'You have unsaved changes to',
    unsavedChecklistMessage: 'Are you sure you want to close without saving?',
    
    // Checklist Audit
    added: 'Added',
    removed: 'Removed',
    completed: 'Completed',
    uncompleted: 'Uncompleted',
    deleted: 'Deleted',
    restored: 'Restored',
    duplicateItemError: 'An item with this name already exists',
    duplicateItemsPreventSave: 'Cannot save: duplicate checklist items found. Please ensure all items have unique names.',
    
    // Column positioning and date formatting
    fixedPosition: 'Fixed Position',
    dateFormatting: 'Date Formatting',
    shortDateFormat: 'Short Date (MM/DD/YYYY)',
    dateTimeFormat: 'Date Time (MM/DD/YYYY HH:MM)',
    manageColumnsDescription: 'Manage column visibility and order for {stage}',
  },
  fr: {
    // Common
    success: 'Succès',
    error: 'Erreur',
    cancel: 'Annuler',
    save: 'Enregistrer',
    delete: 'Supprimer',
    edit: 'Modifier',
    add: 'Ajouter',
    back: 'Retour',
    editWorkItems: 'Modifier les éléments',
    editItems: 'Modifier les éléments',
    addNewField: 'Ajouter un champ',
    close: 'Fermer',
    ok: 'OK',
    option: 'Option',
    filter: 'Filtre',
    clearFilters: 'Effacer les filtres',
    clearSelection: 'Effacer la sélection',
    itemsSelected: 'éléments sélectionnés',
    selectAction: 'Sélectionner une action',
    clickToEdit: 'Cliquer pour modifier',
    today: "Aujourd'hui",
    apply: 'Appliquer',
    search: 'Rechercher',
    
    // Calendar
    january: 'Janvier',
    february: 'Février',
    march: 'Mars',
    april: 'Avril',
    may: 'Mai',
    june: 'Juin',
    july: 'Juillet',
    august: 'Août',
    september: 'Septembre',
    october: 'Octobre',
    november: 'Novembre',
    december: 'Décembre',
    
    sun: 'Dim',
    mon: 'Lun',
    tue: 'Mar',
    wed: 'Mer',
    thu: 'Jeu',
    fri: 'Ven',
    sat: 'Sam',
    
    // Workflow Hub
    workflowHub: 'Hub de Flux de Travail',
    onboarding: 'Intégration',
    active: 'Actif',
    extension: 'Prolongations',
    offboarding: 'Départ',
    complete: 'Terminé',
    
    // Field Modal
    addCustomField: 'Ajouter un champ personnalisé',
    editField: 'Modifier le champ',
    fieldName: 'Nom du champ',
    note: 'Note',
    fieldNotePlaceholder: 'Ajouter une note pour ce champ...',
    noteSupportsHtml: 'La note prend en charge le formatage HTML',
    displayNoteInGrid: 'Afficher la note sur l\'en-tête de colonne',
    displayNoteHelpText: 'Lorsque coché, une icône d\'info avec une note apparaîtra dans l\'en-tête de colonne',
    inputType: "Type d'entrée",
    colorCodeInput: 'Entrée de code couleur',
    allowMultipleSelections: 'Autoriser les sélections multiples',
    dropdownOptions: 'Options de la liste déroulante',
    visibleOnStages: 'Visible sur les étapes',
    backToColumns: 'Retour aux colonnes',
    showVisibleFieldsOnly: 'Afficher uniquement les champs visibles',
    customColumn: 'Colonne personnalisée',
    retainColumnData: 'Conserver les données de colonne',
    retainColumnDataLabel: 'Conserver les données de colonne',
    retainColumnDataDescription: 'Conserve les données de colonne pour le même ID d\'affectation dans tous les nouveaux enregistrements',
    
    // Input Types
    inputTypeText: 'Texte',
    inputTypeYesNo: 'Oui/Non',
    inputTypeDropdown: 'Liste déroulante',
    inputTypeDate: 'Date',
    inputTypeNumber: 'Nombre',
    inputTypeEmail: 'Email',
    inputTypeChecklist: 'Liste de contrôle',
    blank: '(vide)',
    
    // Messages
    fieldCreated: 'Champ personnalisé créé avec succès',
    fieldUpdated: 'Champ mis à jour avec succès',
    fieldDeleted: 'Champ supprimé avec succès',
    noCustomFieldsAvailable: 'Plus de champs personnalisés disponibles. Veuillez en créer de nouveaux ou supprimer les existants.',
    
    // Form placeholders and labels
    selectOptions: 'Sélectionner des options',
    selectOption: 'Sélectionner une option',
    selectDate: 'Sélectionner une date',
    editColumns: 'Modifier les colonnes',
    clear: 'Effacer',
    clearAll: 'Tout effacer',
    showMore: 'Afficher plus',
    typeToFilter: 'Tapez pour filtrer...',
    enterValue: 'Entrer une valeur...',
    startDate: 'Date de début',
    endDateOptional: 'Date de fin (optionnel)',
    noRecordsFound: 'Aucun enregistrement trouvé',
    loading: 'Chargement...',
    previous: 'Précédent',
    next: 'Suivant',
    showingRecords: '{start} à {end} sur {total}',
    pageOf: 'Page {current} sur {total}',
    rowsPer: 'Lignes par page',
    showChangesInProgress: 'Éléments en cours',
    moveTo: 'Déplacer vers',
    areYouSure: 'Êtes-vous sûr ?',
    moveToConfirm: 'Cela mettra à jour {count} enregistrement{s} vers le statut "{status}".',
    yesUpdate: 'Oui, mettre à jour',
    processing: 'Traitement...',
    cancelWorkOrder: 'Annuler la commande de travail',
    goBack: 'Non, retourner',
    openFboWorkOrder: 'Ouvrir la commande de travail FBO',
    noActionsAvailable: 'Aucune action disponible',
    confirmDeleteOption: 'Êtes-vous sûr de vouloir supprimer cette option ?',
    noSuggestions: 'Aucune suggestion trouvée',
    
    // View Selector
    myViews: 'Mes vues',
    teamViews: 'Vues d\'équipe',
    sharedWithMe: 'Partagé avec moi',
    allCompany: 'Toute l\'entreprise',
    saveViewAs: 'Enregistrer la vue sous',
    title: 'Titre',
    myCustomView: 'Ma vue personnalisée',
    description: 'Description',
    addDescriptionForView: 'Ajouter une description pour cette vue',
    showDescriptionOnHover: 'Afficher la description au survol dans la liste déroulante',
    deleteViewConfirmation: 'Êtes-vous sûr de vouloir supprimer cette vue ?',
    deleteViewWarning: 'Cette vue sera supprimée pour tous ceux avec qui elle a été partagée. Vous ne pouvez pas annuler cette action.',
    share: 'Partager',
    saveChanges: 'Enregistrer les modifications',
    changesSuccess: 'Modifications enregistrées avec succès',
    saveAsNew: 'Enregistrer comme nouveau',
    deleteView: 'Supprimer la vue',
    viewNotFound: 'Vue introuvable. Elle a peut-être été supprimée.',
    viewVisibility: 'Visibilité de la vue',
    hideView: 'Masquer la vue',
    viewHidden: 'Vue masquée avec succès',
    viewShown: 'Vue affichée avec succès',
    saveView: 'Enregistrer la vue',
    saveThisView: 'Enregistrer cette vue',
    visibility: 'Visibilité',
    private: 'Privé',
    public: 'Public',
    shareWith: 'Partager avec',
    shareWithPlaceholder: 'Entrez les adresses e-mail',
    
    // Edit Columns Modal
    hiddenColumns: 'Colonnes masquées',
    visibleColumns: 'Colonnes visibles',
    editColumnsSubtitle: 'Masquer, afficher, ordonner, modifier et créer des colonnes personnalisées.',
    nameYourCustomView: 'Nommez votre vue personnalisée',
    
    // Manage Views Modal
    manageViews: 'Gérer les vues',
    searchViews: 'Rechercher des vues',
    showView: 'Afficher la vue',
    view: 'Voir',
    editView: 'Modifier la vue',
    createView: 'Créer une vue',
    noMyViews: 'Aucune vue trouvée',
    noSharedViews: 'Aucune vue partagée trouvée',
    noPublicViews: 'Aucune vue publique trouvée',
    showVisibleViewsOnly: 'Afficher uniquement les vues visibles',
    viewSavedSuccessfully: 'Vue enregistrée avec succès',
    columnConfigurationUpdatedSuccessfully: 'Configuration de colonne mise à jour avec succès',
    failedToSaveView: 'Échec de l\'enregistrement de la vue',
    unsavedChangesTitle: 'Modifications non enregistrées',
    unsavedChangesWarning: 'Vous avez des modifications non enregistrées dans vos filtres. Changer de vue supprimera ces modifications. Êtes-vous sûr de vouloir continuer ?',
    switchView: 'Changer de vue',
    automations: 'Automatisations',
    
    // Audit History
    historyOfChanges: 'Historique des modifications',
    searchChanges: 'Rechercher des modifications...',
    loadingHistory: 'Chargement de l\'historique...',
    noChangesFound: 'Aucune modification trouvée',
    tryAdjustingSearch: 'Essayez d\'ajuster vos termes de recherche',
    changesFound: 'modifications trouvées',
    changeFound: 'modification trouvée',
    new: 'Nouveau',
    by: 'par',
    unknownUser: 'Utilisateur inconnu',
    unknownTime: 'Heure inconnue',
    unknownDate: 'Date inconnue',
    changeReason: 'Raison du changement',
    changes: 'Modifications',
    loadMore: 'Charger plus',
    viewHistory: 'Historique des vues',
    viewMessages: 'Voir les messages',
    pinTooltip: 'Glissez et déposez cette épingle sur n\'importe quelle colonne pour l\'épingler.',
    unpinTooltip: 'Cliquez pour détacher cette colonne ou faites-la glisser vers une autre.',
    confirmBulkUpdate: 'Confirmer la mise à jour en lot',
    bulkUpdateConfirmMessage: 'Vous êtes sur le point de mettre à jour des éléments. Cette action ne peut pas être annulée.',
    confirmUpdateMessage: 'Vous êtes sur le point de mettre à jour {count} enregistrement{s} avec cette action en lot. Souhaitez-vous continuer ?',
    autoProcessIn: 'Traitement automatique dans',
    seconds: 'secondes',
    confirmUpdate: 'Confirmer la mise à jour',
    confirm: 'Confirmer',
    yes: 'Oui',
    no: 'Non',
    someValuesEmpty: 'Certaines valeurs sont vides et effaceront les données existantes.',
    viewSelector: 'Sélecteur de vue',
    
    // Additional Audit History translations
    all: 'Tous',
    lastWeek: 'Dernière semaine',
    lastMonth: 'Dernier mois',
    '90days': '90 jours',
    lastYear: 'Dernière année',
    custom: 'Personnalisé',
    stage: 'Étape',
    true: 'Vrai',
    false: 'Faux',
    changeHistory: 'Historique des modifications',
    automationEmails: 'Emails d\'automatisation',
    historyOf: 'Historique de',
    candidate: 'Candidat',
    allStages: 'Toutes les étapes',
    allUsers: 'Tous les utilisateurs',
    adjustSearchFilters: 'Essayez d\'ajuster votre recherche ou vos filtres',
    showing: 'Affichage de',
    change: 'changement',
    additionalInfo: 'Informations supplémentaires',
    clickToExpand: 'Cliquer pour développer les détails',
    clickToCollapse: 'Cliquer pour réduire les détails',
    featureComingSoon: 'Cette fonctionnalité sera bientôt disponible',
    endDate: 'Date de fin',
    of: 'sur',
    sentTo: 'Envoyé à',
    sentFrom: 'De',
    sentAt: 'Envoyé le',
    subject: 'Sujet',
    noEmailsFound: 'Aucun email trouvé',
    loadingEmails: 'Chargement des emails...',
    searchEmailSubject: 'Rechercher le sujet de l\'email...',
    automationEmailHistoryOf: 'Historique des emails d\'automatisation de',
    stages: 'Étapes',
    selectRecipient: 'Sélectionner le destinataire',
    allRecipients: 'Tous les destinataires',
    to: 'À',
    from: 'De',
    showLess: 'Afficher moins',
    
    // Worker Search
    searchWorkers: 'Rechercher des travailleurs',
    searchWorker: 'Rechercher un travailleur',
    workerResults: 'Résultats des travailleurs',
    workerName: 'Nom du travailleur',
    clientName: 'Client',
    workOrderId: 'ID de commande de travail',
    searchHelperText: 'Tapez au moins 2 caractères pour rechercher des travailleurs',
    
    // Private Columns
    whoCanViewColumn: 'Qui peut voir cette colonne',
    noUsersSelected: 'Aucun utilisateur sélectionné',
    updateColumnAccess: 'Mettre à jour l\'accès à la colonne',
    confirmMakePrivate: 'Rendre la colonne privée',
    confirmMakePrivateMessage: 'Seuls les utilisateurs avec accès pourront voir cette colonne.',
    confirmMakePublic: 'Rendre la colonne publique',
    confirmMakePublicMessage: 'Cette colonne deviendra publique et visible à tous. Les utilisateurs autorisés seront remis à zéro.',
    
    // Private Column
    privateColumn: 'Colonne privée :',
    default: '(par défaut)',
    searchUsersPlaceholder: 'Rechercher des utilisateurs par nom ou email...',
    noUsersFound: 'Aucun utilisateur trouvé',
    privateColumnWarningTitle: 'Avertissement des filtres de colonnes privées',
    privateColumnWarningMessage: 'Cette vue publique contient des filtres sur des colonnes privées. Les autres utilisateurs qui n\'ont pas accès à ces colonnes privées peuvent ne pas voir les mêmes résultats ou rencontrer des erreurs lors de l\'utilisation de cette vue. Êtes-vous sûr de vouloir enregistrer cette vue publique ?',
    saveAnyway: 'Enregistrer quand même',
    
    // Checklist Panel
    worker: 'Travailleur',
    workOrderIdLabel: 'ID de commande',
    itemsCompleted: 'éléments complétés',
    addNewItem: 'Ajouter un nouvel élément',
    unsavedChecklistChanges: 'Vous avez des modifications non enregistrées dans',
    unsavedChecklistMessage: 'Êtes-vous sûr de vouloir fermer sans enregistrer?',
    
    // Checklist Audit
    added: 'Ajouté',
    removed: 'Supprimé',
    completed: 'Complété',
    uncompleted: 'Non complété',
    deleted: 'Supprimé',
    restored: 'Restauré',
    duplicateItemError: 'Un élément avec ce nom existe déjà',
    duplicateItemsPreventSave: 'Impossible d\'enregistrer : des éléments en double ont été trouvés. Veuillez vous assurer que tous les éléments ont des noms uniques.',
    
    // Column positioning and date formatting
    fixedPosition: 'Position fixe',
    dateFormatting: 'Formatage de date',
    shortDateFormat: 'Date courte (MM/JJ/AAAA)',
    dateTimeFormat: 'Date et heure (MM/JJ/AAAA HH:MM)',
    manageColumnsDescription: 'Gérer la visibilité et l\'ordre des colonnes pour {stage}',
  },
}; 